export default __webpack_public_path__ + "static/media/avatar.35049636.svg";